import React, { useEffect, useState } from "react";
import { FiHome, FiPlus } from "react-icons/fi";
import MenuLateral from "../../Components/MenuLateral";
import CadastroPageHeader, { CadastroPanelHeading } from "../../Components/CadastroPageHeader";
import api from "../../services/api";
import { showApiError } from "../../services/showApiError";
import CepAddressLookup from "../../Components/CepAddressLookup";
import FieldLabel from "../../Components/FieldLabel";
import Swal from "sweetalert2";
import "./index.css";
import "../../styles/cadastro-pages.css";

function CadInstituicao() {
  const [id, setId] = useState("");

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [city, setCity] = useState("");
  const [uf, setUf] = useState("");
  const [acronym, setAcronym] = useState("");
  const [campus, setCampus] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [district, setDistrict] = useState("");

  const [lista, setLista] = useState([]);
  const [gridSearch, setGridSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const aplicarEnderecoPorCep = (address) => {
    setStreet(address.street);
    setDistrict(address.district);
    setCity(address.city);
    setUf(address.uf);
  };

  // Carregar instituições
  const carregarInstituicoes = async () => {
    setLoading(true);
    try {
      const response = await api.get("/institution");
      setLista(response.data.institutions || []);
    } catch (error) {
      console.error("Erro ao buscar instituições:", error);
      showApiError(error, "Erro ao carregar");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarInstituicoes();
    // Esta carga ocorre apenas na montagem da pagina.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Limpar formulário
  const limpar = () => {
    setId("");
    setName("");
    setType("");
    setCity("");
    setUf("");
    setAcronym("");
    setCampus("");
    setZipCode("");
    setStreet("");
    setNumber("");
    setComplement("");
    setDistrict("");
  };

  // Salvar (POST ou PUT)
  const salvar = async () => {
    const payload = {
      name,
      type,
      city,
      uf,
      acronym,
      campus,
      zipCode,
      street,
      number,
      complement,
      district
    };

    setLoading(true);
    try {
      if (id) {
        const resp = await api.put(`/institution/${id}`, payload);
        const msg = resp.data?.message || "Instituição atualizada com sucesso!";
        Swal.fire({
          icon: "success",
          title: "Atualizado",
          text: msg
        });
      } else {
        const resp = await api.post("/institution", payload);
        const msg = resp.data?.message || "Instituição cadastrada com sucesso!";
        Swal.fire({
          icon: "success",
          title: "Cadastrado",
          text: msg
        });
      }

      limpar();
      carregarInstituicoes();
    } catch (error) {
      console.error("Erro ao salvar:", error);
      showApiError(error, "Erro ao salvar");
    } finally {
      setLoading(false);
    }
  };

  // Selecionar item do grid
  const selecionar = (item) => {
    setId(item.id);
    setName(item.name);
    setType(item.type);
    setCity(item.city);
    setUf(item.uf);
    setAcronym(item.acronym || "");
    setCampus(item.campus || "");
    setZipCode(item.zipCode || "");
    setStreet(item.street || "");
    setNumber(item.number || "");
    setComplement(item.complement || "");
    setDistrict(item.district || "");
    // rolar para o formulário (opcional)
    const el = document.querySelector(".form-cad");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  // Excluir
  const excluir = async (idToDelete) => {
    const confirm = await Swal.fire({
      title: "Confirma exclusão?",
      text: "Deseja realmente excluir esta instituição?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar"
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const resp = await api.delete(`/institution/${idToDelete}`);
      const msg = resp.data?.message || "Instituição excluída!";
      Swal.fire({
        icon: "success",
        title: "Excluído",
        text: msg
      });
      // Se o item que estava no form foi excluído, limpar
      if (id === idToDelete) limpar();
      carregarInstituicoes();
    } catch (error) {
      console.error("Erro ao excluir:", error);
      showApiError(error, "Erro ao excluir");
    } finally {
      setLoading(false);
    }
  };

  const listaFiltrada = lista.filter((item) =>
    (item.name || "").toLowerCase().includes(gridSearch.trim().toLowerCase()),
  );

  return (
    <div className="pagina-cad cadastro-shell cadastro-shell-instituicoes">
      <MenuLateral />

      <div className="conteudo-cad">
        <CadastroPageHeader
          eyebrow="Cadastros / Estrutura"
          title="Instituições"
          description="Mantenha as instituições organizadas para vincular turmas, alunos e eventos com segurança."
          icon={FiHome}
          context="Base organizacional"
          contextDetail="Instituições disponíveis para os vínculos"
        />

        {/* FORMULÁRIO */}
        <div className="form-cad">
          <CadastroPanelHeading
            eyebrow={id ? "Edição de cadastro" : "Novo cadastro"}
            title={id ? "Atualizar instituição" : "Adicionar instituição"}
            description="Informe os dados essenciais e o endereço que será usado nos vínculos operacionais."
            icon={id ? FiHome : FiPlus}
          />
          <FieldLabel label="Tipo">
            <select
              className="instituicao-tipo-select"
              value={type}
              onChange={(e) => setType(e.target.value)}
              disabled={loading}
            >
              <option value="">Tipo</option>
              <option value="UNIVERSIDADE">Universidade</option>
              <option value="ESCOLA">Escola</option>
              <option value="EMPRESA">Empresa</option>
              <option value="OUTROS">Outros</option>
            </select>
          </FieldLabel>

          <FieldLabel label="Nome da instituição">
            <input
              type="text"
              placeholder="Nome da instituição"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={loading}
            />
          </FieldLabel>

          <FieldLabel label="Sigla">
            <input
              type="text"
              placeholder="Sigla"
              value={acronym}
              onChange={(e) => setAcronym(e.target.value.toUpperCase())}
              disabled={loading}
            />
          </FieldLabel>

          <FieldLabel label="Campus">
            <input
              type="text"
              placeholder="Campus"
              value={campus}
              onChange={(e) => setCampus(e.target.value)}
              disabled={loading}
            />
          </FieldLabel>

          <CepAddressLookup
            address={{ zipCode, street, number, complement, district, city, uf }}
            onZipCodeChange={setZipCode}
            onApplyAddress={aplicarEnderecoPorCep}
            disabled={loading}
          />

          <FieldLabel label="Logradouro">
            <input
              type="text"
              placeholder="Logradouro"
              value={street}
              onChange={(e) => setStreet(e.target.value)}
              disabled={loading}
            />
          </FieldLabel>

          <FieldLabel label="Número">
            <input
              type="text"
              placeholder="Número"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              disabled={loading}
            />
          </FieldLabel>

          <FieldLabel label="Complemento">
            <input
              type="text"
              placeholder="Complemento"
              value={complement}
              onChange={(e) => setComplement(e.target.value)}
              disabled={loading}
            />
          </FieldLabel>

          <FieldLabel label="Bairro">
            <input
              type="text"
              placeholder="Bairro"
              value={district}
              onChange={(e) => setDistrict(e.target.value)}
              disabled={loading}
            />
          </FieldLabel>

          <FieldLabel label="Cidade">
            <input
              type="text"
              placeholder="Cidade"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              disabled={loading}
            />
          </FieldLabel>

          <FieldLabel label="UF">
            <input
              type="text"
              placeholder="UF (Ex: RJ)"
              maxLength="2"
              value={uf}
              onChange={(e) => setUf(e.target.value.toUpperCase())}
              disabled={loading}
            />
          </FieldLabel>

          <div className="botoes">
            <button onClick={salvar} disabled={loading}>
              {id ? "Atualizar" : "Salvar"}
            </button>

            <button
              className="btn-limpar"
              onClick={limpar}
              disabled={loading}
            >
              Limpar
            </button>
          </div>
        </div>

        {/* GRID */}
        <section className="cadastro-list-panel" aria-labelledby="instituicoes-list-title">
          <div className="cadastro-list-heading">
            <div>
              <span className="cadastro-list-kicker">Base operacional</span>
              <h2 id="instituicoes-list-title">Instituições cadastradas</h2>
              <p>Edite os dados ou remova registros que não devem mais participar da operação.</p>
            </div>
            <span className="cadastro-list-count">{listaFiltrada.length} {listaFiltrada.length === 1 ? "item" : "itens"}</span>
          </div>

          <div className="grid-toolbar">
            <FieldLabel label="Buscar por nome">
              <input
                className="grid-search-input"
                type="text"
                placeholder="Buscar por nome"
                value={gridSearch}
                onChange={(e) => setGridSearch(e.target.value)}
              />
            </FieldLabel>
          </div>

          {loading && <p className="cadastro-loading" role="status">Carregando instituições...</p>}

          <div className="cadastro-table-wrap">
          <table className="grid-cad">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Sigla</th>
              <th>Tipo</th>
              <th>Cidade</th>
              <th>UF</th>
              <th width="250">Ações</th>
            </tr>
          </thead>

          <tbody>
            {listaFiltrada.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.acronym || "-"}</td>
                <td>{item.type}</td>
                <td>{item.city}</td>
                <td>{item.uf}</td>
                <td>
                  <button onClick={() => selecionar(item)} disabled={loading}>
                    Editar
                  </button>
                  <button
                    className="btn-excluir"
                    onClick={() => excluir(item.id)}
                    disabled={loading}
                  >
                    Excluir
                  </button>
                </td>
              </tr>
            ))}
            {listaFiltrada.length === 0 && !loading && (
              <tr>
                <td colSpan="6">Nenhuma instituição encontrada.</td>
              </tr>
            )}
          </tbody>
          </table>
          </div>
        </section>
      </div>
    </div>
  );
}

export default CadInstituicao;
